module.exports = __webpack_public_path__ + "media/images/svg/logotype-megia-hijos-0d12e8cbf5caff208c7bc7300e56dfe5.svg";